import { render, staticRenderFns } from "./AssignValidatorsPanel.vue?vue&type=template&id=fbd9e22e&scoped=true&"
import script from "./AssignValidatorsPanel.vue?vue&type=script&lang=js&"
export * from "./AssignValidatorsPanel.vue?vue&type=script&lang=js&"
import style0 from "./AssignValidatorsPanel.vue?vue&type=style&index=0&id=fbd9e22e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd9e22e",
  null
  
)

export default component.exports